// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-videos-card {
  background: var(--swiper-color-surface);
  border-radius: 1.25rem;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}
.swiper-videos-card__media {
  position: relative;
  display: block;
}
.swiper-videos-card__media img {
  width: 100%;
  display: block;
  aspect-ratio: 16/9;
  object-fit: cover;
}
.swiper-videos-card__duration {
  position: absolute;
  bottom: 0.75rem;
  right: 0.75rem;
  background: rgba(15, 23, 42, 0.85);
  color: #fff;
  padding: 0.2rem 0.65rem;
  border-radius: 999px;
  font-size: 0.75rem;
}
.swiper-videos-card__body {
  padding: 1.25rem;
}
.swiper-videos-card__badge {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.7rem;
  margin: 0 0 0.35rem;
  color: var(--swiper-color-accent);
}
.swiper-videos-card p {
  margin: 0;
  color: var(--swiper-color-muted);
}
.swiper-slide--auto {
  flex: 0 0 auto;
  width: auto !important;
}
.swiper-quotes-card {
  background: var(--swiper-color-surface);
  border-radius: 1.25rem;
  padding: 2rem;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.swiper-quotes-card__quote {
  font-size: 1.1rem;
  line-height: 1.6;
  margin: 0 0 1.25rem;
  color: var(--swiper-color-ink);
}
.swiper-quotes-card__author {
  font-weight: 600;
  margin: 0;
}
.swiper-quotes-card__role {
  margin: 0.15rem 0 0;
  color: var(--swiper-color-muted);
  font-size: 0.9rem;
}
.swiper-quotes-card__footer {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}
.swiper-quotes-card__photo {
  width: 56px;
  height: 56px;
  border-radius: 999px;
  overflow: hidden;
  flex: 0 0 auto;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);
  background: var(--swiper-color-surface);
}
.swiper-quotes-card__photo img,
section.dptheme-swiper--news .swiper-slide article .swiper-news-card__media,
section.dptheme-swiper--news .swiper-slide article .swiper-news-card__media img,
section.dptheme-swiper--news
  .swiper-slide
  article
  .swiper-news-card__media
  picture,
section.dptheme-swiper--news
  .swiper-slide
  article
  .swiper-news-card__media-link
  picture,
section.dptheme-swiper--news
  .swiper-slide
  article
  .swiper-news-card__media-link
  img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
section.dptheme-swiper--news
  .swiper-slide
  article
  .swiper-news-card__media-link {
  display: block;
  width: 100%;
  height: 100%;
  color: inherit;
  pointer-events: none;
}
.swiper-quotes-card__meta {
  display: flex;
  flex-direction: column;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.swiper-scrollbar-drag {
  background: var(--swiper-color-accent);
}
.dptheme-swiper--news [data-swiper-root] .swiper-button-next,
.dptheme-swiper--news [data-swiper-root] .swiper-button-prev {
  background: rgba(15, 23, 42, 0.85);
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 999px;
}
.dptheme-swiper--news [data-swiper-root] .swiper-button-next::after,
.dptheme-swiper--news [data-swiper-root] .swiper-button-prev::after {
  font-size: 1rem;
  color: #fff;
}
.dptheme-swiper--news [data-swiper-root] .swiper-pagination-bullet {
  background: rgba(15, 23, 42, 0.3);
  opacity: 1;
}
.dptheme-swiper--news [data-swiper-root] .swiper-pagination-bullet-active {
  background: var(--swiper-color-accent);
}
.dptheme-swiper__heading {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 1.25rem;
}
.dptheme-swiper__kicker {
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.75rem;
  color: var(--swiper-color-accent);
  margin: 0;
}
.dptheme-swiper__heading h2 {
  font-size: clamp(1.5rem, 3vw, 2.5rem);
  margin: 0;
}
:root {
  --swiper-news-height: 520px;
  --swiper-news-inactive-height: 16%;
  --swiper-news-adjustment-multiplier: 2.01;
  --swiper-news-max-width: 1200px;
  --swiper-news-active-height: 317px;
  --swiper-color-surface: #ffffff;
  --swiper-color-ink: #0f172a;
  --swiper-color-muted: #475467;
  --swiper-color-accent: #2563eb;
}
@media (min-width: 768px) {
  :root {
    --swiper-news-height: 620px;
    --swiper-news-inactive-height: 8%;
    --swiper-news-adjustment-multiplier: 2.39;
  }
}
div.swiper-news-outer {
  --swiper-navigation-size: 2.3em;
  --swiper-pagination-right: 0;
  --swiper-pagination-bullet-width: 1em;
  --swiper-pagination-bullet-height: 1em;
  --swiper-pagination-bullet-vertical-gap: 0.8em;
  min-height: var(--swiper-news-height);
}
section.dptheme-swiper--news {
  position: relative;
  width: 100%;
  margin-inline: auto;
  color: var(--swiper-color-ink);
}
section.dptheme-swiper--news .swiper {
  height: var(--swiper-news-height);
}
section.dptheme-swiper--news .swiper-wrapper {
  height: 100% !important;
  transform: none !important;
  transition: none !important;
}
section.dptheme-swiper--news .swiper-slide {
  height: calc(
    100% - var(--swiper-news-inactive-height) *
      var(--swiper-news-adjustment-multiplier)
  ) !important;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  margin-bottom: 0 !important;
  cursor: pointer;
  transition: transform var(--dp-anim-speed) var(--dp-anim-ease);
}
section.dptheme-swiper--news .swiper-pagination {
  display: none;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 0.25em;
}
section.dptheme-swiper--news .swiper-button-next,
section.dptheme-swiper--news .swiper-button-prev {
  display: none;
  left: calc(98% - var(--swiper-navigation-size)) !important;
  margin: 0 !important;
  border: 1px solid var(--dp-clr-01-light);
  box-shadow: 0 0 9px rgba(0, 0, 0, 0.4);
}
section.dptheme-swiper--news svg.swiper-navigation-icon {
  width: 0.9rem !important;
  filter: brightness(1.7);
}
section.dptheme-swiper--news .swiper-button-disabled {
  opacity: 0 !important;
  transition: opacity var(--dp-anim-speed) var(--dp-anim-ease);
}
section.dptheme-swiper--news
  .swiper-slide[aria-label="1 / 4"][data-slide-state="active"] {
  z-index: 4;
  transform: translate3d(
    0,
    calc(0% + var(--swiper-news-inactive-height) * 0),
    0
  );
}
section.dptheme-swiper--news
  .swiper-slide[aria-label="1 / 4"][data-slide-state="pre"] {
  z-index: 4;
  transform: translate3d(
    0,
    calc(-100% + var(--swiper-news-inactive-height) * 1),
    0
  );
}
section.dptheme-swiper--news
  .swiper-slide[aria-label="2 / 4"][data-slide-state="active"],
section.dptheme-swiper--news
  .swiper-slide[aria-label="2 / 4"][data-slide-state="post"] {
  z-index: 3;
  transform: translate3d(
    0,
    calc(0% + var(--swiper-news-inactive-height) * 1),
    0
  );
}
section.dptheme-swiper--news
  .swiper-slide[aria-label="2 / 4"][data-slide-state="pre"] {
  z-index: 3;
  transform: translate3d(
    0,
    calc(-100% + var(--swiper-news-inactive-height) * 2),
    0
  );
}
section.dptheme-swiper--news
  .swiper-slide[aria-label="3 / 4"][data-slide-state="active"],
section.dptheme-swiper--news
  .swiper-slide[aria-label="3 / 4"][data-slide-state="post"] {
  z-index: 2;
  transform: translate3d(
    0,
    calc(0% + var(--swiper-news-inactive-height) * 2),
    0
  );
}
section.dptheme-swiper--news
  .swiper-slide[aria-label="3 / 4"][data-slide-state="pre"] {
  z-index: 2;
  transform: translate3d(
    0,
    calc(-100% + var(--swiper-news-inactive-height) * 3),
    0
  );
}
section.dptheme-swiper--news
  .swiper-slide[aria-label="4 / 4"][data-slide-state="active"],
section.dptheme-swiper--news
  .swiper-slide[aria-label="4 / 4"][data-slide-state="post"] {
  z-index: 1;
  transform: translate3d(
    0,
    calc(0% + var(--swiper-news-inactive-height) * 3),
    0
  );
}
section.dptheme-swiper--news .swiper-slide article {
  position: relative;
  height: 100%;
  overflow: hidden;
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
}
section.dptheme-swiper--news
  .swiper-slide
  article
  .swiper-news-card__media::after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background: rgba(0, 114, 157, 0.85);
  position: absolute;
  top: 0;
  left: 0;
  transition: background var(--dp-anim-speed) var(--dp-anim-ease);
  pointer-events: none;
}
section.dptheme-swiper--news .swiper-slide article .swiper-news-card__overlay {
  max-width: var(--swiper-news-max-width, var(--dp-bp-lg));
  margin: 0 auto;
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: #fff;
  transition:
    background-color var(--dp-anim-speed) var(--dp-anim-ease),
    padding var(--dp-anim-speed) var(--dp-anim-ease);
  pointer-events: none;
}
@media (min-width: 768px) {
  section.dptheme-swiper--news
    .swiper-slide
    article
    .swiper-news-card__overlay {
    background-color: transparent;
    padding: 0;
  }
}
section.dptheme-swiper--news
  .swiper-slide
  article
  .swiper-news-card__headline-outer {
  min-height: var(--swiper-news-inactive-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
section.dptheme-swiper--news
  .swiper-slide
  article
  .swiper-news-card__headline-outer::after {
  content: "+";
  display: flex;
  font-size: 2rem;
  line-height: 1;
  text-shadow: 1px 1px 4px #000;
  margin: 0 0.5em;
}
section.dptheme-swiper--news
  .swiper-slide
  article
  .swiper-news-card__headline-outer
  p.swiper-news-card__badge {
  align-self: flex-start;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  padding: 0.25rem 0.75rem;
  margin-bottom: 1rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.6rem;
  position: absolute;
  bottom: 200%;
  max-width: 100%;
  opacity: 0;
  transition: opacity var(--dp-anim-speed) var(--dp-anim-ease);
}
section.dptheme-swiper--news
  .swiper-slide
  article
  .swiper-news-card__headline-outer
  h3 {
  font-size: 1rem;
  margin: 0 1em;
  text-shadow: 1px 1px 4px #000;
  font-weight: 700;
  text-wrap: auto;
  transition:
    margin-bottom var(--dp-anim-speed) var(--dp-anim-ease),
    font-size var(--dp-anim-speed) var(--dp-anim-ease);
}
section.dptheme-swiper--news
  .swiper-slide
  article
  .swiper-news-card__content-outer
  a.swiper-news-card__cta,
section.dptheme-swiper--news
  .swiper-slide
  article
  .swiper-news-card__content-outer
  p {
  position: absolute;
  bottom: -100%;
  max-width: 100%;
  font-size: 0.9rem;
  line-height: 1.2;
  margin: 0 0.9em 1em;
  opacity: 0;
  transition:
    position var(--dp-anim-speed) var(--dp-anim-ease),
    bottom var(--dp-anim-speed) var(--dp-anim-ease),
    opacity var(--dp-anim-speed) var(--dp-anim-ease);
}
section.dptheme-swiper--news
  .swiper-slide
  article
  .swiper-news-card__content-outer
  a.swiper-news-card__cta {
  align-self: flex-start;
  background: #fff;
  color: #0f172a;
  border-radius: 999px;
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  line-height: 1;
  padding: 0.5em 1em;
  margin: 0 0.9em;
  pointer-events: auto;
}
section.dptheme-swiper--news
  .swiper-slide
  article[data-card-state="active"]
  .swiper-news-card__media-link {
  pointer-events: auto;
}
section.dptheme-swiper--news
  .swiper-slide
  article[data-card-state="active"]
  .swiper-news-card__media::after {
  background: linear-gradient(0deg, rgba(0, 27, 63, 0.9) 0, transparent 80%);
}
section.dptheme-swiper--news
  .swiper-slide
  article[data-card-state="active"]
  .swiper-news-card__overlay {
  padding: 0 0 1em;
  margin-top: auto;
  height: fit-content;
  background-color: rgba(0, 38, 90, 0.7882352941);
}
@media (min-width: 768px) {
  section.dptheme-swiper--news
    .swiper-slide
    article[data-card-state="active"]
    .swiper-news-card__overlay {
    flex-direction: row;
    background-color: transparent;
    padding: 0;
    align-items: flex-end;
  }
}
section.dptheme-swiper--news
  .swiper-slide
  article[data-card-state="active"]
  .swiper-news-card__headline-outer {
  display: block;
  justify-content: normal;
}
@media (min-width: 768px) {
  section.dptheme-swiper--news
    .swiper-slide
    article[data-card-state="active"]
    .swiper-news-card__headline-outer {
    display: flex;
    flex-direction: column;
    margin-bottom: 2em;
  }
}
section.dptheme-swiper--news
  .swiper-slide
  article[data-card-state="active"]
  .swiper-news-card__headline-outer::after {
  display: none;
}
section.dptheme-swiper--news
  .swiper-slide
  article[data-card-state="active"]
  .swiper-news-card__headline-outer
  p.swiper-news-card__badge {
  opacity: 1;
  position: relative;
  width: fit-content;
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  margin: 0.5em 1.1em;
}
@media (min-width: 768px) {
  section.dptheme-swiper--news
    .swiper-slide
    article[data-card-state="active"]
    .swiper-news-card__headline-outer
    p.swiper-news-card__badge {
    font-size: 0.8rem;
  }
}
section.dptheme-swiper--news
  .swiper-slide
  article[data-card-state="active"]
  .swiper-news-card__headline-outer
  h3 {
  font-size: 1.5rem;
  text-wrap: balance;
  margin: 0 0.5em 0.3em;
}
@media (min-width: 768px) {
  section.dptheme-swiper--news
    .swiper-slide
    article[data-card-state="active"]
    .swiper-news-card__headline-outer
    h3 {
    font-size: 1.9rem;
  }
}
@media (min-width: 992px) {
  section.dptheme-swiper--news
    .swiper-slide
    article[data-card-state="active"]
    .swiper-news-card__headline-outer
    h3 {
    font-size: 2.5rem;
  }
}
@media (min-width: 768px) {
  section.dptheme-swiper--news
    .swiper-slide
    article[data-card-state="active"]
    .swiper-news-card__content-outer {
    background-color: rgba(0, 38, 92, 0.85);
    display: flex;
    flex-direction: column;
    padding: 1em 0.5em;
    max-width: 50%;
  }
}
section.dptheme-swiper--news
  .swiper-slide
  article[data-card-state="active"]
  .swiper-news-card__content-outer
  p {
  opacity: 1;
  position: relative;
  bottom: 0;
}
@media (min-width: 768px) {
  section.dptheme-swiper--news
    .swiper-slide
    article[data-card-state="active"]
    .swiper-news-card__content-outer
    p {
    font-size: 1.1rem;
    line-height: 1.4;
  }
}
section.dptheme-swiper--news
  .swiper-slide
  article[data-card-state="active"]
  .swiper-news-card__content-outer
  a {
  margin-bottom: 0;
  position: relative;
  bottom: 0;
  opacity: 1;
}
section.dptheme-swiper--news .swiper-slide[data-slide-state="active"] {
  cursor: auto;
}
div.swiper-videos-outer {
  margin-bottom: 3em;
  min-height: 291px;
}
@media (min-width: 1400px) {
  div.swiper-videos-outer {
    height: 330px;
  }
}
section.dptheme-swiper--videos .swiper-wrapper {
  margin: 3em 0;
}
.swiper-videos-card {
  border-radius: 0;
  position: relative;
  width: clamp(330px, 30vw, 400px);
}
.swiper-videos-card .swiper-videos-card__body,
.swiper-videos-card::after {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.swiper-videos-card__body h3 {
  font-size: 1.3rem;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 0.25em;
}
.swiper-videos-card__body p {
  font-size: 0.9rem;
  color: #fff;
  line-height: 1.2;
}
p.swiper-videos-card__badge {
  font-weight: 700;
  font-size: 0.7rem;
  margin-bottom: 0.6em;
  background-color: var(--dp-clr-03-light);
  width: fit-content;
  padding: 0.35em 0.8em;
  border-radius: 1em;
  color: var(--dp-clr-01-dark);
  margin-left: -0.05em;
  text-shadow: none;
  line-height: 1;
  box-shadow: 2px 2px 7px rgba(0, 0, 0, 0.3);
}
.swiper-videos-card__body {
  height: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  z-index: 2;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.6);
  padding: 1.25em 1.25em 1.7em;
}
span.swiper-videos-card__duration {
  z-index: 2;
}
.wp-block-group.fullwidth.swiper-videos-outer {
  background-color: #eee;
}
.swiper-videos-card::after {
  content: "";
  display: flex;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 34, 67, 0.76);
}
.play-icon,
.swiper-video-modal-overlay {
  align-items: center;
  justify-content: center;
}
.play-icon {
  --size: var(--play-icon-size, 4em);
  width: var(--size);
  aspect-ratio: 1;
  display: inline-flex;
  color: var(--dp-clr-02-darker);
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  filter: drop-shadow(0 0 11px #fff);
  mix-blend-mode: soft-light;
  pointer-events: none;
}
.play-icon::before {
  content: "";
  width: 0;
  height: 0;
  border-top: calc(var(--size) / 2) solid transparent;
  border-bottom: calc(var(--size) / 2) solid transparent;
  border-left: calc(var(--size) * 0.75) solid currentColor;
}
.swiper-video-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.85);
  display: flex;
  padding: 1.5rem;
  z-index: 9999;
}
.swiper-video-modal {
  width: 100%;
  max-width: 800px;
  aspect-ratio: 16/9;
  max-height: calc(100vh - 3rem);
  background: var(--swiper-color-surface);
  color: var(--swiper-color-ink);
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.25);
  position: relative;
}
.swiper-video-modal__header {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1rem;
}
.swiper-video-modal__close {
  appearance: none;
  border: 1px solid rgba(15, 23, 42, 0.2);
  background: var(--swiper-color-surface);
  border-radius: 999px;
  padding: 0.45rem 0.9rem;
  font-weight: 600;
  cursor: pointer;
}
.swiper-video-modal__body {
  height: 100%;
}
.swiper-video-modal__player {
  width: 100%;
  height: 100%;
  background: var(--swiper-color-ink);
}
.swiper-video-modal__player iframe {
  width: 100%;
  height: 100%;
}
.swiper-video-modal__message {
  margin: 0;
  padding: 1rem;
}
section.dptheme-swiper--news
  [data-slide-state="active"]
  > article.no-content
  > .swiper-news-card__media::after,
section.dptheme-swiper--news
  [data-slide-state="active"]
  > article.no-content
  > .swiper-news-card__overlay {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles.min.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,sBAAsB;EACtB,8CAA8C;EAC9C,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,uCAAuC;EACvC,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,uCAAuC;AACzC;AACA;;;;;;;;;;;;;;;;;;EAkBE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;;;;EAIE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,sCAAsC;AACxC;AACA;;EAEE,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;AACA;;EAEE,eAAe;EACf,WAAW;AACb;AACA;EACE,iCAAiC;EACjC,UAAU;AACZ;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;EACjC,SAAS;AACX;AACA;EACE,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,yCAAyC;EACzC,+BAA+B;EAC/B,kCAAkC;EAClC,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE;IACE,2BAA2B;IAC3B,iCAAiC;IACjC,yCAAyC;EAC3C;AACF;AACA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,sCAAsC;EACtC,8CAA8C;EAC9C,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE;;;cAGY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,eAAe;EACf,8DAA8D;AAChE;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,0DAA0D;EAC1D,oBAAoB;EACpB,wCAAwC;EACxC,sCAAsC;AACxC;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,4DAA4D;AAC9D;AACA;;EAEE,UAAU;EACV;;;;GAIC;AACH;AACA;;EAEE,UAAU;EACV;;;;GAIC;AACH;AACA;;;;EAIE,UAAU;EACV;;;;GAIC;AACH;AACA;;EAEE,UAAU;EACV;;;;GAIC;AACH;AACA;;;;EAIE,UAAU;EACV;;;;GAIC;AACH;AACA;;EAEE,UAAU;EACV;;;;GAIC;AACH;AACA;;;;EAIE,UAAU;EACV;;;;GAIC;AACH;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iDAAiD;AACnD;AACA;;;;EAIE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,+DAA+D;EAC/D,oBAAoB;AACtB;AACA;EACE,wDAAwD;EACxD,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX;;oDAEkD;EAClD,oBAAoB;AACtB;AACA;EACE;;;;IAIE,6BAA6B;IAC7B,UAAU;EACZ;AACF;AACA;;;;EAIE,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;;;;EAIE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,eAAe;AACjB;AACA;;;;;EAKE,sBAAsB;EACtB,qCAAqC;EACrC,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,4DAA4D;AAC9D;AACA;;;;;EAKE,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf;;sDAEoD;AACtD;AACA;;;;;;;;;;EAUE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV;;;oDAGkD;AACpD;AACA;;;;;EAKE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA;;;;EAIE,oBAAoB;AACtB;AACA;;;;EAIE,0EAA0E;AAC5E;AACA;;;;EAIE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE;;;;IAIE,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;IACV,qBAAqB;EACvB;AACF;AACA;;;;EAIE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE;;;;IAIE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;AACF;AACA;;;;EAIE,aAAa;AACf;AACA;;;;;EAKE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,SAAS;EACT,mBAAmB;AACrB;AACA;EACE;;;;;IAKE,iBAAiB;EACnB;AACF;AACA;;;;;EAKE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE;;;;;IAKE,iBAAiB;EACnB;AACF;AACA;EACE;;;;;IAKE,iBAAiB;EACnB;AACF;AACA;EACE;;;;IAIE,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;;;;;EAKE,UAAU;EACV,kBAAkB;EAClB,SAAS;AACX;AACA;EACE;;;;;IAKE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;;;;;EAKE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;EACV,2CAA2C;EAC3C,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uCAAuC;AACzC;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kCAAkC;EAClC,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mDAAmD;EACnD,sDAAsD;EACtD,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,uCAAuC;EACvC,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,uCAAuC;EACvC,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;EACT,aAAa;AACf;AACA;;;;;;;;EAQE,UAAU;AACZ","sourcesContent":[".swiper-videos-card {\r\n  background: var(--swiper-color-surface);\r\n  border-radius: 1.25rem;\r\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);\r\n  overflow: hidden;\r\n}\r\n.swiper-videos-card__media {\r\n  position: relative;\r\n  display: block;\r\n}\r\n.swiper-videos-card__media img {\r\n  width: 100%;\r\n  display: block;\r\n  aspect-ratio: 16/9;\r\n  object-fit: cover;\r\n}\r\n.swiper-videos-card__duration {\r\n  position: absolute;\r\n  bottom: 0.75rem;\r\n  right: 0.75rem;\r\n  background: rgba(15, 23, 42, 0.85);\r\n  color: #fff;\r\n  padding: 0.2rem 0.65rem;\r\n  border-radius: 999px;\r\n  font-size: 0.75rem;\r\n}\r\n.swiper-videos-card__body {\r\n  padding: 1.25rem;\r\n}\r\n.swiper-videos-card__badge {\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n  font-size: 0.7rem;\r\n  margin: 0 0 0.35rem;\r\n  color: var(--swiper-color-accent);\r\n}\r\n.swiper-videos-card p {\r\n  margin: 0;\r\n  color: var(--swiper-color-muted);\r\n}\r\n.swiper-slide--auto {\r\n  flex: 0 0 auto;\r\n  width: auto !important;\r\n}\r\n.swiper-quotes-card {\r\n  background: var(--swiper-color-surface);\r\n  border-radius: 1.25rem;\r\n  padding: 2rem;\r\n  min-height: 220px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n}\r\n.swiper-quotes-card__quote {\r\n  font-size: 1.1rem;\r\n  line-height: 1.6;\r\n  margin: 0 0 1.25rem;\r\n  color: var(--swiper-color-ink);\r\n}\r\n.swiper-quotes-card__author {\r\n  font-weight: 600;\r\n  margin: 0;\r\n}\r\n.swiper-quotes-card__role {\r\n  margin: 0.15rem 0 0;\r\n  color: var(--swiper-color-muted);\r\n  font-size: 0.9rem;\r\n}\r\n.swiper-quotes-card__footer {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.85rem;\r\n}\r\n.swiper-quotes-card__photo {\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n  flex: 0 0 auto;\r\n  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);\r\n  background: var(--swiper-color-surface);\r\n}\r\n.swiper-quotes-card__photo img,\r\nsection.dptheme-swiper--news .swiper-slide article .swiper-news-card__media,\r\nsection.dptheme-swiper--news .swiper-slide article .swiper-news-card__media img,\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article\r\n  .swiper-news-card__media\r\n  picture,\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article\r\n  .swiper-news-card__media-link\r\n  picture,\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article\r\n  .swiper-news-card__media-link\r\n  img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article\r\n  .swiper-news-card__media-link {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  color: inherit;\r\n  pointer-events: none;\r\n}\r\n.swiper-quotes-card__meta {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n.swiper-scrollbar-drag {\r\n  background: var(--swiper-color-accent);\r\n}\r\n.dptheme-swiper--news [data-swiper-root] .swiper-button-next,\r\n.dptheme-swiper--news [data-swiper-root] .swiper-button-prev {\r\n  background: rgba(15, 23, 42, 0.85);\r\n  width: 2.75rem;\r\n  height: 2.75rem;\r\n  border-radius: 999px;\r\n}\r\n.dptheme-swiper--news [data-swiper-root] .swiper-button-next::after,\r\n.dptheme-swiper--news [data-swiper-root] .swiper-button-prev::after {\r\n  font-size: 1rem;\r\n  color: #fff;\r\n}\r\n.dptheme-swiper--news [data-swiper-root] .swiper-pagination-bullet {\r\n  background: rgba(15, 23, 42, 0.3);\r\n  opacity: 1;\r\n}\r\n.dptheme-swiper--news [data-swiper-root] .swiper-pagination-bullet-active {\r\n  background: var(--swiper-color-accent);\r\n}\r\n.dptheme-swiper__heading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.35rem;\r\n  margin-bottom: 1.25rem;\r\n}\r\n.dptheme-swiper__kicker {\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.12em;\r\n  font-size: 0.75rem;\r\n  color: var(--swiper-color-accent);\r\n  margin: 0;\r\n}\r\n.dptheme-swiper__heading h2 {\r\n  font-size: clamp(1.5rem, 3vw, 2.5rem);\r\n  margin: 0;\r\n}\r\n:root {\r\n  --swiper-news-height: 520px;\r\n  --swiper-news-inactive-height: 16%;\r\n  --swiper-news-adjustment-multiplier: 2.01;\r\n  --swiper-news-max-width: 1200px;\r\n  --swiper-news-active-height: 317px;\r\n  --swiper-color-surface: #ffffff;\r\n  --swiper-color-ink: #0f172a;\r\n  --swiper-color-muted: #475467;\r\n  --swiper-color-accent: #2563eb;\r\n}\r\n@media (min-width: 768px) {\r\n  :root {\r\n    --swiper-news-height: 620px;\r\n    --swiper-news-inactive-height: 8%;\r\n    --swiper-news-adjustment-multiplier: 2.39;\r\n  }\r\n}\r\ndiv.swiper-news-outer {\r\n  --swiper-navigation-size: 2.3em;\r\n  --swiper-pagination-right: 0;\r\n  --swiper-pagination-bullet-width: 1em;\r\n  --swiper-pagination-bullet-height: 1em;\r\n  --swiper-pagination-bullet-vertical-gap: 0.8em;\r\n  min-height: var(--swiper-news-height);\r\n}\r\nsection.dptheme-swiper--news {\r\n  position: relative;\r\n  width: 100%;\r\n  margin-inline: auto;\r\n  color: var(--swiper-color-ink);\r\n}\r\nsection.dptheme-swiper--news .swiper {\r\n  height: var(--swiper-news-height);\r\n}\r\nsection.dptheme-swiper--news .swiper-wrapper {\r\n  height: 100% !important;\r\n  transform: none !important;\r\n  transition: none !important;\r\n}\r\nsection.dptheme-swiper--news .swiper-slide {\r\n  height: calc(\r\n    100% - var(--swiper-news-inactive-height) *\r\n      var(--swiper-news-adjustment-multiplier)\r\n  ) !important;\r\n  overflow: hidden;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  margin-bottom: 0 !important;\r\n  cursor: pointer;\r\n  transition: transform var(--dp-anim-speed) var(--dp-anim-ease);\r\n}\r\nsection.dptheme-swiper--news .swiper-pagination {\r\n  display: none;\r\n  background-color: rgba(255, 255, 255, 0.7);\r\n  padding: 0.25em;\r\n}\r\nsection.dptheme-swiper--news .swiper-button-next,\r\nsection.dptheme-swiper--news .swiper-button-prev {\r\n  display: none;\r\n  left: calc(98% - var(--swiper-navigation-size)) !important;\r\n  margin: 0 !important;\r\n  border: 1px solid var(--dp-clr-01-light);\r\n  box-shadow: 0 0 9px rgba(0, 0, 0, 0.4);\r\n}\r\nsection.dptheme-swiper--news svg.swiper-navigation-icon {\r\n  width: 0.9rem !important;\r\n  filter: brightness(1.7);\r\n}\r\nsection.dptheme-swiper--news .swiper-button-disabled {\r\n  opacity: 0 !important;\r\n  transition: opacity var(--dp-anim-speed) var(--dp-anim-ease);\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide[aria-label=\"1 / 4\"][data-slide-state=\"active\"] {\r\n  z-index: 4;\r\n  transform: translate3d(\r\n    0,\r\n    calc(0% + var(--swiper-news-inactive-height) * 0),\r\n    0\r\n  );\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide[aria-label=\"1 / 4\"][data-slide-state=\"pre\"] {\r\n  z-index: 4;\r\n  transform: translate3d(\r\n    0,\r\n    calc(-100% + var(--swiper-news-inactive-height) * 1),\r\n    0\r\n  );\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide[aria-label=\"2 / 4\"][data-slide-state=\"active\"],\r\nsection.dptheme-swiper--news\r\n  .swiper-slide[aria-label=\"2 / 4\"][data-slide-state=\"post\"] {\r\n  z-index: 3;\r\n  transform: translate3d(\r\n    0,\r\n    calc(0% + var(--swiper-news-inactive-height) * 1),\r\n    0\r\n  );\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide[aria-label=\"2 / 4\"][data-slide-state=\"pre\"] {\r\n  z-index: 3;\r\n  transform: translate3d(\r\n    0,\r\n    calc(-100% + var(--swiper-news-inactive-height) * 2),\r\n    0\r\n  );\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide[aria-label=\"3 / 4\"][data-slide-state=\"active\"],\r\nsection.dptheme-swiper--news\r\n  .swiper-slide[aria-label=\"3 / 4\"][data-slide-state=\"post\"] {\r\n  z-index: 2;\r\n  transform: translate3d(\r\n    0,\r\n    calc(0% + var(--swiper-news-inactive-height) * 2),\r\n    0\r\n  );\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide[aria-label=\"3 / 4\"][data-slide-state=\"pre\"] {\r\n  z-index: 2;\r\n  transform: translate3d(\r\n    0,\r\n    calc(-100% + var(--swiper-news-inactive-height) * 3),\r\n    0\r\n  );\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide[aria-label=\"4 / 4\"][data-slide-state=\"active\"],\r\nsection.dptheme-swiper--news\r\n  .swiper-slide[aria-label=\"4 / 4\"][data-slide-state=\"post\"] {\r\n  z-index: 1;\r\n  transform: translate3d(\r\n    0,\r\n    calc(0% + var(--swiper-news-inactive-height) * 3),\r\n    0\r\n  );\r\n}\r\nsection.dptheme-swiper--news .swiper-slide article {\r\n  position: relative;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  border-bottom: 2px solid rgba(255, 255, 255, 0.3);\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article\r\n  .swiper-news-card__media::after {\r\n  content: \"\";\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 114, 157, 0.85);\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  transition: background var(--dp-anim-speed) var(--dp-anim-ease);\r\n  pointer-events: none;\r\n}\r\nsection.dptheme-swiper--news .swiper-slide article .swiper-news-card__overlay {\r\n  max-width: var(--swiper-news-max-width, var(--dp-bp-lg));\r\n  margin: 0 auto;\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  color: #fff;\r\n  transition:\r\n    background-color var(--dp-anim-speed) var(--dp-anim-ease),\r\n    padding var(--dp-anim-speed) var(--dp-anim-ease);\r\n  pointer-events: none;\r\n}\r\n@media (min-width: 768px) {\r\n  section.dptheme-swiper--news\r\n    .swiper-slide\r\n    article\r\n    .swiper-news-card__overlay {\r\n    background-color: transparent;\r\n    padding: 0;\r\n  }\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article\r\n  .swiper-news-card__headline-outer {\r\n  min-height: var(--swiper-news-inactive-height);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article\r\n  .swiper-news-card__headline-outer::after {\r\n  content: \"+\";\r\n  display: flex;\r\n  font-size: 2rem;\r\n  line-height: 1;\r\n  text-shadow: 1px 1px 4px #000;\r\n  margin: 0 0.5em;\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article\r\n  .swiper-news-card__headline-outer\r\n  p.swiper-news-card__badge {\r\n  align-self: flex-start;\r\n  background: rgba(255, 255, 255, 0.12);\r\n  border-radius: 999px;\r\n  padding: 0.25rem 0.75rem;\r\n  margin-bottom: 1rem;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n  font-size: 0.6rem;\r\n  position: absolute;\r\n  bottom: 200%;\r\n  max-width: 100%;\r\n  opacity: 0;\r\n  transition: opacity var(--dp-anim-speed) var(--dp-anim-ease);\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article\r\n  .swiper-news-card__headline-outer\r\n  h3 {\r\n  font-size: 1rem;\r\n  margin: 0 1em;\r\n  text-shadow: 1px 1px 4px #000;\r\n  font-weight: 700;\r\n  text-wrap: auto;\r\n  transition:\r\n    margin-bottom var(--dp-anim-speed) var(--dp-anim-ease),\r\n    font-size var(--dp-anim-speed) var(--dp-anim-ease);\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article\r\n  .swiper-news-card__content-outer\r\n  a.swiper-news-card__cta,\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article\r\n  .swiper-news-card__content-outer\r\n  p {\r\n  position: absolute;\r\n  bottom: -100%;\r\n  max-width: 100%;\r\n  font-size: 0.9rem;\r\n  line-height: 1.2;\r\n  margin: 0 0.9em 1em;\r\n  opacity: 0;\r\n  transition:\r\n    position var(--dp-anim-speed) var(--dp-anim-ease),\r\n    bottom var(--dp-anim-speed) var(--dp-anim-ease),\r\n    opacity var(--dp-anim-speed) var(--dp-anim-ease);\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article\r\n  .swiper-news-card__content-outer\r\n  a.swiper-news-card__cta {\r\n  align-self: flex-start;\r\n  background: #fff;\r\n  color: #0f172a;\r\n  border-radius: 999px;\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n  text-decoration: none;\r\n  line-height: 1;\r\n  padding: 0.5em 1em;\r\n  margin: 0 0.9em;\r\n  pointer-events: auto;\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article[data-card-state=\"active\"]\r\n  .swiper-news-card__media-link {\r\n  pointer-events: auto;\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article[data-card-state=\"active\"]\r\n  .swiper-news-card__media::after {\r\n  background: linear-gradient(0deg, rgba(0, 27, 63, 0.9) 0, transparent 80%);\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article[data-card-state=\"active\"]\r\n  .swiper-news-card__overlay {\r\n  padding: 0 0 1em;\r\n  margin-top: auto;\r\n  height: fit-content;\r\n  background-color: rgba(0, 38, 90, 0.7882352941);\r\n}\r\n@media (min-width: 768px) {\r\n  section.dptheme-swiper--news\r\n    .swiper-slide\r\n    article[data-card-state=\"active\"]\r\n    .swiper-news-card__overlay {\r\n    flex-direction: row;\r\n    background-color: transparent;\r\n    padding: 0;\r\n    align-items: flex-end;\r\n  }\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article[data-card-state=\"active\"]\r\n  .swiper-news-card__headline-outer {\r\n  display: block;\r\n  justify-content: normal;\r\n}\r\n@media (min-width: 768px) {\r\n  section.dptheme-swiper--news\r\n    .swiper-slide\r\n    article[data-card-state=\"active\"]\r\n    .swiper-news-card__headline-outer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-bottom: 2em;\r\n  }\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article[data-card-state=\"active\"]\r\n  .swiper-news-card__headline-outer::after {\r\n  display: none;\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article[data-card-state=\"active\"]\r\n  .swiper-news-card__headline-outer\r\n  p.swiper-news-card__badge {\r\n  opacity: 1;\r\n  position: relative;\r\n  width: fit-content;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  bottom: 0;\r\n  margin: 0.5em 1.1em;\r\n}\r\n@media (min-width: 768px) {\r\n  section.dptheme-swiper--news\r\n    .swiper-slide\r\n    article[data-card-state=\"active\"]\r\n    .swiper-news-card__headline-outer\r\n    p.swiper-news-card__badge {\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article[data-card-state=\"active\"]\r\n  .swiper-news-card__headline-outer\r\n  h3 {\r\n  font-size: 1.5rem;\r\n  text-wrap: balance;\r\n  margin: 0 0.5em 0.3em;\r\n}\r\n@media (min-width: 768px) {\r\n  section.dptheme-swiper--news\r\n    .swiper-slide\r\n    article[data-card-state=\"active\"]\r\n    .swiper-news-card__headline-outer\r\n    h3 {\r\n    font-size: 1.9rem;\r\n  }\r\n}\r\n@media (min-width: 992px) {\r\n  section.dptheme-swiper--news\r\n    .swiper-slide\r\n    article[data-card-state=\"active\"]\r\n    .swiper-news-card__headline-outer\r\n    h3 {\r\n    font-size: 2.5rem;\r\n  }\r\n}\r\n@media (min-width: 768px) {\r\n  section.dptheme-swiper--news\r\n    .swiper-slide\r\n    article[data-card-state=\"active\"]\r\n    .swiper-news-card__content-outer {\r\n    background-color: rgba(0, 38, 92, 0.85);\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 1em 0.5em;\r\n    max-width: 50%;\r\n  }\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article[data-card-state=\"active\"]\r\n  .swiper-news-card__content-outer\r\n  p {\r\n  opacity: 1;\r\n  position: relative;\r\n  bottom: 0;\r\n}\r\n@media (min-width: 768px) {\r\n  section.dptheme-swiper--news\r\n    .swiper-slide\r\n    article[data-card-state=\"active\"]\r\n    .swiper-news-card__content-outer\r\n    p {\r\n    font-size: 1.1rem;\r\n    line-height: 1.4;\r\n  }\r\n}\r\nsection.dptheme-swiper--news\r\n  .swiper-slide\r\n  article[data-card-state=\"active\"]\r\n  .swiper-news-card__content-outer\r\n  a {\r\n  margin-bottom: 0;\r\n  position: relative;\r\n  bottom: 0;\r\n  opacity: 1;\r\n}\r\nsection.dptheme-swiper--news .swiper-slide[data-slide-state=\"active\"] {\r\n  cursor: auto;\r\n}\r\ndiv.swiper-videos-outer {\r\n  margin-bottom: 3em;\r\n  min-height: 291px;\r\n}\r\n@media (min-width: 1400px) {\r\n  div.swiper-videos-outer {\r\n    height: 330px;\r\n  }\r\n}\r\nsection.dptheme-swiper--videos .swiper-wrapper {\r\n  margin: 3em 0;\r\n}\r\n.swiper-videos-card {\r\n  border-radius: 0;\r\n  position: relative;\r\n  width: clamp(330px, 30vw, 400px);\r\n}\r\n.swiper-videos-card .swiper-videos-card__body,\r\n.swiper-videos-card::after {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  pointer-events: none;\r\n}\r\n.swiper-videos-card__body h3 {\r\n  font-size: 1.3rem;\r\n  font-weight: 700;\r\n  line-height: 1.1;\r\n  margin-bottom: 0.25em;\r\n}\r\n.swiper-videos-card__body p {\r\n  font-size: 0.9rem;\r\n  color: #fff;\r\n  line-height: 1.2;\r\n}\r\np.swiper-videos-card__badge {\r\n  font-weight: 700;\r\n  font-size: 0.7rem;\r\n  margin-bottom: 0.6em;\r\n  background-color: var(--dp-clr-03-light);\r\n  width: fit-content;\r\n  padding: 0.35em 0.8em;\r\n  border-radius: 1em;\r\n  color: var(--dp-clr-01-dark);\r\n  margin-left: -0.05em;\r\n  text-shadow: none;\r\n  line-height: 1;\r\n  box-shadow: 2px 2px 7px rgba(0, 0, 0, 0.3);\r\n}\r\n.swiper-videos-card__body {\r\n  height: 100%;\r\n  color: #fff;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  z-index: 2;\r\n  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.6);\r\n  padding: 1.25em 1.25em 1.7em;\r\n}\r\nspan.swiper-videos-card__duration {\r\n  z-index: 2;\r\n}\r\n.wp-block-group.fullwidth.swiper-videos-outer {\r\n  background-color: #eee;\r\n}\r\n.swiper-videos-card::after {\r\n  content: \"\";\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 1;\r\n  background-color: rgba(0, 34, 67, 0.76);\r\n}\r\n.play-icon,\r\n.swiper-video-modal-overlay {\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.play-icon {\r\n  --size: var(--play-icon-size, 4em);\r\n  width: var(--size);\r\n  aspect-ratio: 1;\r\n  display: inline-flex;\r\n  color: var(--dp-clr-02-darker);\r\n  position: absolute;\r\n  z-index: 2;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  filter: drop-shadow(0 0 11px #fff);\r\n  mix-blend-mode: soft-light;\r\n  pointer-events: none;\r\n}\r\n.play-icon::before {\r\n  content: \"\";\r\n  width: 0;\r\n  height: 0;\r\n  border-top: calc(var(--size) / 2) solid transparent;\r\n  border-bottom: calc(var(--size) / 2) solid transparent;\r\n  border-left: calc(var(--size) * 0.75) solid currentColor;\r\n}\r\n.swiper-video-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(15, 23, 42, 0.85);\r\n  display: flex;\r\n  padding: 1.5rem;\r\n  z-index: 9999;\r\n}\r\n.swiper-video-modal {\r\n  width: 100%;\r\n  max-width: 800px;\r\n  aspect-ratio: 16/9;\r\n  max-height: calc(100vh - 3rem);\r\n  background: var(--swiper-color-surface);\r\n  color: var(--swiper-color-ink);\r\n  border-radius: 1rem;\r\n  overflow: hidden;\r\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.25);\r\n  position: relative;\r\n}\r\n.swiper-video-modal__header {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  z-index: 2;\r\n  padding: 1rem;\r\n}\r\n.swiper-video-modal__close {\r\n  appearance: none;\r\n  border: 1px solid rgba(15, 23, 42, 0.2);\r\n  background: var(--swiper-color-surface);\r\n  border-radius: 999px;\r\n  padding: 0.45rem 0.9rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n.swiper-video-modal__body {\r\n  height: 100%;\r\n}\r\n.swiper-video-modal__player {\r\n  width: 100%;\r\n  height: 100%;\r\n  background: var(--swiper-color-ink);\r\n}\r\n.swiper-video-modal__player iframe {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.swiper-video-modal__message {\r\n  margin: 0;\r\n  padding: 1rem;\r\n}\r\nsection.dptheme-swiper--news\r\n  [data-slide-state=\"active\"]\r\n  > article.no-content\r\n  > .swiper-news-card__media::after,\r\nsection.dptheme-swiper--news\r\n  [data-slide-state=\"active\"]\r\n  > article.no-content\r\n  > .swiper-news-card__overlay {\r\n  opacity: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
